/**
 * Get total value of campaign including any creator pledge. This can be
 * different the pool balance due to pledges, pool withdrawls, creator having
 * a negative balance when a contributor chips-in, etc.
 * @param {number} currentValue - total value of contributions to pool
 * @param {number} pledge - total pledge made by pool creator
 * @reutrns {number} total value of campaign contributions including pledge
 */
export function getCampaignTotalValue({ currentValue = 0, pledge = 0 }) {
  return currentValue + pledge
}

export function getCampaignType(store, campaignId) {
  const state = store.getState()
  return (
    state.campaign &&
    state.campaign[campaignId] &&
    state.campaign[campaignId].campaign_type
  )
}
